import * as React from 'react'

// Components
import PaymentBlock, {
  PaymentBlockFields,
} from 'pages/business/components/payment-block'
import UserPaymentMethod from 'pages/business/user/billing-settings/payment-method'

// Modules
import { DI } from 'modules'

const PaymentMethod = ({ common, form, onValidateForm, user }) => {
  // Setup
  const { strings } = common

  const prefix = 'page.billing.payment'

  return (
    <PaymentBlock
      text={strings[`${prefix}.text`]}
      title={strings[`${prefix}.title`]}
    >
      <PaymentBlockFields>
        <UserPaymentMethod
          form={form}
          onValidateForm={onValidateForm}
          user={user}
        />
      </PaymentBlockFields>
    </PaymentBlock>
  )
}

export default DI(['common', 'user'])(PaymentMethod)
